import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FinancialProductWarrantiesEditHeaderContainer from './components/header/FinancialProductWarrantiesEditHeaderContainer';
import FinancialProductWarrantyEditFiltersContainer from './components/filters/FinancialProductWarrantyEditFiltersContainer';
import { FINANCIAL_PRODUCT_WARRANTY_QUERY } from './queries';
import { useQuery } from 'hooks/apollo';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import { GENERIC_ENTITY_BUSINESS_STATES_FLOW_QUERY, FINANCIAL_PRODUCT_STATE_QUERY } from '../../../../queries';

const FinancialProductWarrantiesEditContainer = ({
  canWrite,
  productId,
  leasingFinancialProductXWarrantyId,
  onRedirect,
  onChangeTitle
}) => {
  const { data, loading } = useQuery(FINANCIAL_PRODUCT_WARRANTY_QUERY, {
    variables: { leasingFinancialProductXWarrantyId },
    skip: leasingFinancialProductXWarrantyId === undefined || leasingFinancialProductXWarrantyId === null
  });

  const { data: financialProductState } = useQuery(FINANCIAL_PRODUCT_STATE_QUERY, {
    variables: { productId },
    skip: !productId
  });

  const { data: allStates } = useQuery(GENERIC_ENTITY_BUSINESS_STATES_FLOW_QUERY, {
    variables: { flowId: financialProductState?.financialProductState?.flowId },
    skip: !financialProductState
  });

  const financialProductEditableState = useMemo(() => {
    if (financialProductState?.financialProductState?.currentStateId)
      return allStates?.genericEntityBusinessStatesXFlow?.find(
        item => item.id === financialProductState?.financialProductState?.currentStateId
      )?.editableYN;

    return false;
  }, [allStates, financialProductState?.financialProductState?.currentStateId]);

  return (
    <>
      {loading ? (
        <Card>
          <FakeText lines={15} />
        </Card>
      ) : (
        <>
          <FinancialProductWarrantiesEditHeaderContainer
            canWrite={canWrite && financialProductEditableState}
            data={data?.financialProductWarranty}
            productId={productId}
            onRedirect={onRedirect}
            onChangeTitle={onChangeTitle}
          />
          <FinancialProductWarrantyEditFiltersContainer
            canWrite={canWrite && financialProductEditableState}
            leasingFinancialProductXWarrantyId={leasingFinancialProductXWarrantyId}
            templateId={data?.financialProductWarranty?.genericFilterTemplateId}
          />
        </>
      )}
    </>
  );
};

FinancialProductWarrantiesEditContainer.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  productId: PropTypes.number.isRequired,
  leasingFinancialProductXWarrantyId: PropTypes.number,
  onRedirect: PropTypes.func,
  onChangeTitle: PropTypes.func
};

export default FinancialProductWarrantiesEditContainer;
